import { useQuery } from 'react-query';
import api from '~/services/api';

export const useCamposFiltrosObrigatorios = (codTela: number): any => {
  return useQuery({
    queryKey: ['telaCamposFiltrosObrigatorios', codTela],
    queryFn: async () => {
      const { data } = await api.get(
        `/tela-campos-filtros-obrigatorios/${codTela}`,
      );
      return data;
    },
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 30,
    enabled: !!codTela,
  });
};
